import { http } from "../Common/http";
import React from "react";
import { useAuth } from "../Auth/Auth";
import { Select } from "antd";

const { Option } = Select;

interface Props {
  masterType: number;
  fy?: string;
  ucode?: string;
  fid?: string;
  allowClear?: boolean;
  width?: number;
  value?: string;
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
  allowSetDefaultValue?: boolean;
}

interface CommonMasterData {
  id: string;
  name: string;
}

const getCommonMasterDatas = async (
  masterType: number,
  accessToken: string,
  ucode?: string,
  fid?: string,
  fy?: string
): Promise<CommonMasterData[]> => {
  let path = `/Master/${masterType}`;
  if (ucode || fid || fy) {
    path = path + "?";
    if (ucode) {
      path = path + `ucode=${ucode}&`;
    }
    if (fid) {
      path = path + `fid=${fid}&`;
    }
    if (fy) {
      path = path + `fy=${fy}`;
    }
  }

  const result = await http<CommonMasterData[]>({
    path: path,
    accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

const getUniversitys = async (
  accessToken: string
): Promise<CommonMasterData[]> => {
  const result = await http<CommonMasterData[]>({
    path: `/Master/universitys`,
    accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

const getUserTypes = async (
  accessToken: string,
  ucode?: string
): Promise<CommonMasterData[]> => {
  let path = `/Master/usertypes`;
  if (ucode) {
    path = path + `?ucode=${ucode}`;
  }

  const result = await http<CommonMasterData[]>({
    path: path,
    accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

const getYears = async (
  accessToken: string,
  ucode?: string
): Promise<CommonMasterData[]> => {
  let path = `/Master/years`;
  if (ucode) {
    path = path + `?bflag=${ucode}`;
  }
  const result = await http<CommonMasterData[]>({
    path: path,
    accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

export const CommonMasterSelect = ({
  masterType,
  ucode,
  fid,
  fy,
  allowClear = true,
  width = 160,
  value,
  onChange,
  disabled = false,
  allowSetDefaultValue = false,
}: Props) => {
  const { accessToken } = useAuth();
  const [datas, setDatas] = React.useState<CommonMasterData[]>([]);
  // const [selValue, setSelValue] = React.useState<string | undefined>(value);
  const [loaded, setLoaded] = React.useState(false);
  React.useEffect(() => {
    const doGetMasterDatas = async () => {
      if (loaded) {
        onSelectClear();
      }
      if (masterType === 1) {
        const gotDatas = await getUniversitys(accessToken);
        setDatas(gotDatas);
      } else if (masterType === 6) {
        if (!ucode || ucode == null || ucode.length === 0) {
          setDatas([]);
          return;
        }
        const gotDatas = await getUserTypes(accessToken, ucode);
        setDatas(gotDatas);
      } else if (masterType === 31) {
        const gotDatas = await getYears(accessToken, ucode);
        setDatas(gotDatas);
      } else {
        if (
          ((masterType >= 3 && masterType <= 5) ||
            (masterType >= 22 && masterType <= 24) ||
            (masterType >= 26 && masterType <= 27)) &&
          (!fid || fid == null || fid.length === 0)
        ) {
          setDatas([]);
          return;
        }
        if (
          masterType >= 20 &&
          masterType <= 30 &&
          (!fy || fy == null || fy.length === 0)
        ) {
          setDatas([]);
          return;
        }
        const gotDatas = await getCommonMasterDatas(
          masterType,
          accessToken,
          ucode,
          fid,
          fy
        );
        setDatas(gotDatas);
        if (allowSetDefaultValue && gotDatas.length === 1) {
          onSelectChange({ value: gotDatas[0].id, label: gotDatas[0].name });
        }
      }
      if (!loaded) {
        setLoaded(true);
        // onSelectChange(selValue);
      }
    };
    doGetMasterDatas();
    // onChange?.("");
    // eslint-disable-next-line
  }, [ucode, fid, fy]);

  const onSelectChange = (newValue: any) => {
    // console.log(newValue);
    // setSelValue(newValue);
    onChange?.(newValue);
  };

  const onSelectClear = () => {
    // setSelValue({ value: "" });
    onChange?.(undefined);
  };
  return (
    <Select
      labelInValue
      allowClear={allowClear}
      style={{ width: width }}
      value={value}
      // defaultValue={selValue}
      onChange={onSelectChange}
      // onClear={onSelectClear}
      disabled={disabled}
    >
      {datas.length > 0 &&
        datas.map((data) => (
          <Option key={data.id} value={data.id}>
            {data.name}
          </Option>
        ))}
    </Select>
  );
};
